module.exports = __webpack_public_path__ + "img/crypto1.7aaba355.png";